/* eslint-disable max-len */
/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './RatingCard.scss'

export const RATING_CARD_POSITION_PERSONAL = (qualificationFp) => (
    <FormattedMessage
        id='rating.card.position.personal'
        defaultMessage='Для участия в рейтинге вам необходимо набрать Очков славы: {qualificationFp}'
        values={{
            qualificationFp: (
                <span className={styles.important}>{qualificationFp}</span>
            ),
        }}
    />
)

export const RATING_CARD_POSITION_CLAN_PERIODIC = (
    <FormattedMessage
        id='rating.card.position.clan.periodic'
        defaultMessage='Для участия в рейтинге за неделю на счету вашего клана должны быть заработанные Очки славы'
    />
)

export const RATING_CARD_POSITION_CLAN_PFP = (
    <FormattedMessage
        id='rating.card.position.clan.PFP'
        defaultMessage='Для участия в общем рейтинге вашему клану необходимо набрать Очки славы'
    />
)

export const RATING_CARD_POSITION_CLAN_BATTLES = (qualificationBattles) => (
    <FormattedMessage
        id='rating.card.position.clan.ballles'
        defaultMessage='Для участия в общем рейтинге вашему клану необходимо провести боёв: {qualificationBattles}'
        values={{
            qualificationBattles: (
                <span className={styles.important}>{qualificationBattles}</span>
            ),
        }}
    />
)

export const RATING_CARD_POSITION_CLAN = (qualificationFp, qualificationBattles) => (
    <FormattedMessage
        id='rating.card.position.clan'
        defaultMessage='Для участия в общем рейтинге вашему клану необходимо набрать Очки славы и провести боёв: {qualificationBattles}'
        values={{
            qualificationBattles: (
                <span className={styles.important}>{qualificationBattles}</span>
            ),
        }}
    />
)

export const LEADERBOARDS_PERSONAL_PERIODIC = (
    <FormattedMessage
        id='leaderboards.personal.periodic'
        defaultMessage='Личный рейтинг за день'
    />
)

export const LEADERBOARDS_CLAN_PERIODIC = (
    <FormattedMessage
        id='leaderboards.clan.periodic'
        defaultMessage='Клановый рейтинг за неделю'
    />
)

export const LEADERBOARDS_CLAN = (
    <FormattedMessage
        id='leaderboards.clan'
        defaultMessage='Клановый общий рейтинг'
    />
)

export const LEADERBOARDS_ALL_THE_TIME = (DatePeriod) => (
    <FormattedMessage
        id='leaderboards.all.the.time'
        defaultMessage='За всё событие: {DatePeriod}'
        values={{
            DatePeriod: DatePeriod,
        }}
    />
)

export const LEADERBOARDS_RATING_POSITION_PERSONAL = (
    <FormattedMessage
        id='leaderboards.rating.position.personal'
        defaultMessage='моя позиция в рейтинге'
    />
)

export const LEADERBOARDS_RATING_POSITION_CLAN = (
    <FormattedMessage
        id='leaderboards.rating.position.clan'
        defaultMessage='позиция клана в рейтинге'
    />
)

export const LEADERBOARDS_RATING_DESCRIPTION_PERSONAL = (
    <FormattedMessage
        id='leaderboards.rating.description.personal'
        defaultMessage='Награды можно будет получить после окончания игрового дня'
    />
)

export const LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC = (date) => (
    <FormattedMessage
        id='leaderboards.description.clan.periodic'
        defaultMessage='Награды будут перечислены в казну клана {date}'
        values={{
            date: date,
        }}
    />
)

export const LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC_NOT_DEFINED = (
    <FormattedMessage
        id='leaderboards.description.clan.periodic.not.defined'
        defaultMessage='Награды будут рассчитаны после определения лидеров по Личному рейтингу'
    />
)

export const LEADERBOARDS_DESCRIPTION_TOP_PERSONAL = (top) => (
    <FormattedMessage
        id='leaderboards.description.top.personal'
        defaultMessage='Вы не попали в топ-{top} награждаемых позиций рейтинга'
        values={{
            top: (
                <span className={styles.important}>{top}</span>
            ),
        }}
    />
)

export const LEADERBOARDS_DESCRIPTION_TOP_CLAN = (top) => (
    <FormattedMessage
        id='leaderboards.description.top.clan'
        defaultMessage='Ваш клан не попал в топ-{top} награждаемых позиций рейтинга'
        values={{
            top: (
                <span className={styles.important}>{top}</span>
            ),
        }}
    />
)

export const LEADERBOARDS_RATING_DESCRIPTION_CLAN = (
    <FormattedMessage
        id='leaderboards.rating.description.clan'
        defaultMessage='Награды будут перечислены игрокам клана после завершения события'
    />
)

export const LEADERBOARDS_RATING_DESCRIPTION_NOT_DEFINED = (
    <FormattedMessage
        id='leaderboards.rating.description.personal.not.defined'
        defaultMessage='Количество награждаемых позиций рейтинга будет определено после завершения ближайших боёв'
    />
)



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/RatingCard/translations.jsx